import { GlobalStore } from "store/global/GlobalStore";
import { Token } from "store/global/TokenEnum";
import { estimateWrapping, isWrapToken } from "utils/wrapUtils";
import { WalletClient } from "viem";
import { usePublicClient, useWalletClient } from "wagmi";
import { NETWORK_TO_TOKEN_ADDRESS_MAP } from "../../config/consts";
import { useTokenListByChain } from "hooks/useTokenListByChain";

export const useGetMaxAmountToWrap = () => {
  const network = GlobalStore.useState(s => s.network);
  const balances = GlobalStore.useState(s => s.balances);
  const { data: walletClient } = useWalletClient();
  const publicClient = usePublicClient();
  const tokenList = useTokenListByChain();

  return async (symbol: Token) => {
    const maxBalanceForSymbol = balances.find(balance => balance.symbol === symbol)?.balance;
    if (isWrapToken(symbol, network)) {
      return maxBalanceForSymbol;
    }
    if (maxBalanceForSymbol == null || tokenList == null) {
      return null;
    }
    const gasCost = await estimateWrapping(
      "deposit",
      NETWORK_TO_TOKEN_ADDRESS_MAP[network.id][symbol],
      maxBalanceForSymbol,
      walletClient as WalletClient,
      publicClient,
      symbol,
      tokenList
    );

    return maxBalanceForSymbol.sub(gasCost);
  };
};
